import React, { useState } from "react";
import { useGoogleSyncStore } from "../../stores/googleSyncStore";
import { useCalendarStore } from "../../stores/calendarStore";
import { addCalDavSource, removeSyncSource, type SyncSourceInfo } from "../../lib/googleApi";
import { SyncSourceList } from "./SyncSourceList";

export function CalDavSection() {
  const [serverUrl, setServerUrl] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const syncSources = useGoogleSyncStore((s) => s.syncSources);
  const fetchStatus = useGoogleSyncStore((s) => s.fetchStatus);
  const fetchCalendars = useCalendarStore((s) => s.fetch);

  const caldavSources = syncSources.filter((s) => s.type === "caldav");

  const handleConnect = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      const result = await addCalDavSource(serverUrl, username, password);
      const names = result.calendars.map((c) => c.name).join(", ");
      setMessage(`Connected ${result.calendars.length} calendar(s): ${names}`);
      setServerUrl("");
      setUsername("");
      setPassword("");
      await fetchStatus();
      await fetchCalendars();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to connect");
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (source: SyncSourceInfo) => {
    if (!confirm(`Remove "${source.calendarSummary}"? The calendar and all its events will be deleted.`)) {
      return;
    }
    try {
      await removeSyncSource(source.id);
      await fetchStatus();
      await fetchCalendars();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to remove");
    }
  };

  return (
    <div className="settings-section">
      <p className="settings-eyebrow">CalDAV</p>
      <p className="settings-desc">
        Connect to a CalDAV server (Nextcloud, Radicale, iCloud, etc.).
      </p>

      <SyncSourceList
        label="Connected calendars"
        sources={caldavSources}
        fallbackName="CalDAV Calendar"
        onRemove={handleRemove}
      />

      <form onSubmit={handleConnect}>
        <div className="form-group">
          <label className="label" htmlFor="caldav-url">Server URL</label>
          <input
            id="caldav-url"
            className="input"
            type="url"
            placeholder="https://nextcloud.example.com/remote.php/dav"
            value={serverUrl}
            onChange={(e) => setServerUrl(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label className="label" htmlFor="caldav-user">Username</label>
          <input
            id="caldav-user"
            className="input"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label className="label" htmlFor="caldav-pass">Password</label>
          <input
            id="caldav-pass"
            className="input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {error && <p className="error-text">{error}</p>}
        {message && <p className="success-text">{message}</p>}

        <div className="form-actions" style={{ justifyContent: "flex-start" }}>
          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? "Connecting..." : "Connect"}
          </button>
        </div>
      </form>
    </div>
  );
}
